export default class Validator {
    constructor() {
        this.decimalSeparator = ',';
    }

    zipcode(value) {
        return !!(value.match(/^[1-9][0-9]{3}(-[0-9]{3})?$/));
    }
}
